import { Inject, Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { Audit } from '../models/audit.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { API_BASE_URL } from '../../../shared/tokens/api.tokens';
import { AuditItem } from '../models/audit-item.model';
import { catchError, Observable } from 'rxjs';
import { ResultSet } from '../../../shared/models/result-set.model';

@Injectable({
  providedIn: 'root'
})
export class AuditService extends ApiService<Audit> {

  override searchFields: string[] = ['email', 'firstName', 'lastName'];
  override _baseUrl: string;

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}audits/`;    
  }  

  getAuditItems(auditId: number, offset: number = 0, limit: number=10) { 
    const params = new HttpParams()
    .set('offset', offset.toString())
    .set('limit', limit.toString());  
    return this.http.get<ResultSet<AuditItem>>(`${this._baseUrl}${auditId}/items/`, { params }).pipe(
          catchError(this.handleError)
    );
  }
}

  